import { render, staticRenderFns } from "./LocationFormModal.vue?vue&type=template&id=2b4d431a&scoped=true&"
import script from "./LocationFormModal.vue?vue&type=script&lang=js&"
export * from "./LocationFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d431a",
  null
  
)

export default component.exports